<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="'/'">Home</a></li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto">
  <div class="page-sheet flex flex-col gap-4">
    @for (jobType of ["bod", "not", "tld", "jnd", "tlw", "tps", "tpe"]; track $index) {
      <hawk-qm-page-table [jobs]="jobs" [jobType]="jobType" (jobUpdated)="jobUpdated()" />
    }
  </div>
</div>
